'use client';

import React from 'react';

import Loading from '@/components/common/Loading';

const LoadingModal: React.FC = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
      <div className="flex justify-center items-center min-w-[100px] min-h-[100px] bg-gray-900 bg-opacity-25 border-0 rounded-lg outline-none focus:outline-none">
        {/* me-0だとなぜか優先されない。以下のように[0]として単位を外すことで優先された */}
        <Loading className="w-8 h-8 me-[0] text-gray-400" />
      </div>
    </div>
  );
};

export default LoadingModal;
